<template>
  <div class="settings-container">
    <div class="change-password-container">
      <h3>{{ $t('profile.change_pass.title') }}</h3>

      <form @submit.prevent="handleSubmit">
        <div class="form-group">
          <label for="currentPassword">{{ $t('profile.change_pass.current') }}</label>
          <input
            v-model="currentPassword"
            type="password"
            id="currentPassword"
            :placeholder="$t('profile.change_pass.current_placeholder')"
            required
          />
        </div>

        <div class="form-group">
          <label for="newPassword">{{ $t('profile.change_pass.new') }}</label>
          <input
            v-model="newPassword"
            type="password"
            id="newPassword"
            :placeholder="$t('profile.change_pass.new_placeholder')"
            required
          />
        </div>

        <div class="form-group">
          <label for="confirmPassword">{{ $t('profile.change_pass.confirm') }}</label>
          <input
            v-model="confirmPassword"
            type="password"
            id="confirmPassword"
            :placeholder="$t('profile.change_pass.confirm_placeholder')"
            required
          />
        </div>

        <button class="confirm" type="submit">{{ $t('profile.change_pass.submit') }}</button>
      </form>

      <div v-if="passwordMessage" :class="passwordMessageClass">
        {{ passwordMessage }}
      </div>
    </div>

    <div class="twofa-settings-container">
      <h3>{{ $t('profile.two_fa.title') }}</h3>

      <!-- 2FA Açıklama Kutusu -->
      <div class="info-box">
        <p><strong>{{ $t('profile.two_fa.what_is_title') }}</strong></p>
        <p>{{ $t('profile.two_fa.description1') }}</p>
        <p>{{ $t('profile.two_fa.description2') }}</p>
      </div>

      <div v-if="loading" class="loading-message">{{ $t('common.loading') }}</div>

      <div v-else>
        <p class="status-fa green" v-if="twofaEnabled">{{ $t('profile.two_fa.status_on') }}</p>
        <p class="status-fa" v-else>{{ $t('profile.two_fa.status_off') }}</p>

        <div v-if="twofaMessage" :class="twofaMessageClass">{{ twofaMessage }}</div>

        <button @click="toggle2FA" :disabled="loading">
          {{ twofaEnabled ? $t('profile.two_fa.turn_off') : $t('profile.two_fa.turn_on') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      // Şifre Değiştirme İçin
      currentPassword: "",   
      newPassword: "",       
      confirmPassword: "",    
      passwordMessage: "",        
      passwordMessageClass: "",   

      // 2FA Ayarları İçin
      twofaEnabled: false,  
      loading: false,      
      twofaMessage: '',      
      twofaMessageClass: '',  
    };
  },
  mounted() {
    this.get2FAStatus();
  },
  methods: {
    // Şifre Değiştirme İşlemi
    async handleSubmit() {
      if (this.newPassword !== this.confirmPassword) {
        this.passwordMessage = this.$t('profile.change_pass.mismatch');
        this.passwordMessageClass = "error";
        return;
      }

      try {
        const response = await axios.post("/promo/changepassword", {
          currentPassword: this.currentPassword,
          newPassword: this.newPassword,
        });

        this.passwordMessage = response.data.message;
        this.passwordMessageClass = "success";

        this.currentPassword = "";
        this.newPassword = "";
        this.confirmPassword = "";
      } catch (error) { 
        if (error.response) {
          this.passwordMessage = error.response.data.message;
        } else {
          this.passwordMessage = this.$t('profile.change_pass.generic_error');
        }
        this.passwordMessageClass = "error";
      }
    },

    // 2FA Durumunu Getir
    async get2FAStatus() {
      try {
        this.loading = true;
        const response = await axios.get('/promo/get2fastatus');
        this.twofaEnabled = response.data.twofaEnabled;
      } catch (error) {
        this.twofaMessage = this.$t('profile.two_fa.status_error');
        this.twofaMessageClass = "error";
      } finally {
        this.loading = false;
      }
    },

    // 2FA'yı Aç/Kapa
    async toggle2FA() {
      this.loading = true;
      try {
        const enable = !this.twofaEnabled;
        const response = await axios.post('/promo/update2fastatus', { enable });

        this.twofaMessage = response.data.message;
        this.twofaMessageClass = 'success';
        this.twofaEnabled = enable;
      } catch (error) {
        this.twofaMessage = error.response ? error.response.data.message : this.$t('profile.two_fa.generic_error');
        this.twofaMessageClass = "error";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.settings-container {
  display: flex;
  gap: 20px;
  max-width: 900px;
  margin: auto;
  padding: 20px;
  flex-wrap: wrap;
}

.change-password-container,
.twofa-settings-container {
  flex: 1;
  padding: 20px;
  border-radius: 10px;
  background-color: #050505;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h3 {
  text-align: center;
}

.form-group {
  margin-bottom: 15px;
}

label { 
  margin-bottom: 5px;
  display: block;
}

input {
  width: 100%;
  padding: 10px;
  margin-top: 5px; 
  border-radius: 5px;
}

button {
  width: 100%;
  padding: 10px; 
  border: none;
  cursor: pointer;
  border-radius: 5px; 
  margin-top: 20px;
}

button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
 
.info-box p {
  margin: 0 0 10px; 
}

.info-box p:last-child {
  margin-bottom: 0;
}

.loading-message {
  text-align: center;
  color: #888;
}

.success {
  color: green;
  text-align: center;
  margin-top: 10px;
}

.error {
  color: red;
  text-align: center;
  margin-top: 10px;
}
.status-fa {
  font-size: 1.2em;
}
.green {
  color: green;
}
@media (max-width: 600px) {
  .settings-container { 
   flex-direction: column;
  }
}
</style>